import React, { useState } from "react";
import Style from "./style.module.scss";
import banner1 from "@Assets/Images/banner1.png";
import banner2 from "@Assets/Images/banner2.png";

import Icon from "@Atom/Icon";
export default function BannerLandingPage({ className }) {
  const images = [banner1, banner2, banner1];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  return (
    <div className={className}>
      <div className={Style.wrapperBanner}>
        <div className={Style.relativeButton}>
          <div className={Style.leftIcon} onClick={prevImage}>
            <Icon icon={"arrow-left"} className={Style.iconL} />
          </div>
          <div className={Style.rightIcon} onClick={nextImage}>
            <Icon icon={"arrow-left"} className={Style.iconR} />
          </div>
          {/* {images.map((image, index) => ( */}
          <img
            // key={index}
            // src={image}
            // alt={`Images ${index}`}
            // className={index === currentImageIndex ? Style.active : ""}
            src={banner1}
            alt=""
            className={Style.active}
          />
          {/* ))} */}
        </div>
        <section className={Style.currentActve}>
          {images.map((_, index) => (
            <div
              key={index}
              className={
                index === currentImageIndex ? Style.isActived : Style.isActive
              }
            ></div>
          ))}
        </section>
      </div>
    </div>
  );
}
